module.exports = __webpack_public_path__ + "img/qr 1.6fefcb0c.svg";